import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import SEOHead from '../../components/base/SEOHead';

const EventsPage = () => {
  const events = [
    {
      id: 2,
      day: 'Tuesday',
      title: 'Jam Night during High Season',
      time: '7:00 PM - 10:00 PM',
      description: 'Bring your instruments and join our weekly jam session!',
      icon: 'ri-music-2-line',
      color: 'from-blue-600 to-cyan-500',
      image: 'https://public.readdy.ai/ai/img_res/1b9647a819e0b24d26e326d10abaec12.jpg',
    },
    {
      id: 1,
      day: 'Wednesday',
      title: "Flip Night w/ Karaoke",
      time: '8:00 PM - Close',
      description: 'Join us for Flip Night - flip a coin for a free drink! Sing your heart out with karaoke all night long.',
      icon: 'ri-music-2-line',
      color: 'from-purple-600 to-pink-500',
      image: 'https://readdy.ai/api/search-image?query=fun%20karaoke%20night%20at%20tropical%20bar%20people%20singing%20with%20microphone%20coin%20flip%20drinking%20game%20festive%20atmosphere%20florida%20keys%20pub%20setting%20energetic%20crowd%20simple%20background&width=800&height=600&seq=flipnight-karaoke-wed&orientation=landscape',
    },
    {
      day: 'Thursday',
      title: 'Steak Night',
      time: '5:00 PM - Close',
      description: 'A local favorite for over 20 years! Every Thursday, we serve premium steaks grilled to perfection. Choose from ribeye, New York strip, or filet mignon, served with your choice of sides. Reservations recommended.',
      icon: 'ri-restaurant-line',
      color: 'from-red-600 to-orange-500',
      image: 'https://readdy.ai/api/search-image?query=premium%20grilled%20ribeye%20steak%20on%20white%20ceramic%20plate%20with%20small%20loaded%20baked%20potato%20topped%20with%20light%20cheddar%20cheese%20bacon%20bits%20and%20parsley%20garnish%20restaurant%20presentation%20professional%20food%20photography&width=800&height=600&seq=steak-plate-tuesday-v4&orientation=landscape',
    },
    {
      day: 'Sunday',
      title: 'Live Music After Football Season',
      time: '2:00 PM - 5:00 PM',
      description: 'Relax and unwind every Sunday afternoon with live acoustic performances on our outdoor patio. Enjoy ocean breezes, tropical cocktails, and the sounds of talented local musicians. Perfect way to end your weekend in the Keys!',
      icon: 'ri-guitar-line',
      color: 'from-blue-600 to-cyan-500',
      image: 'https://theocean-view.com/wp-content/uploads/2016/03/phoca_thumb_l_ov74.jpg',
    },
  ];

  const structuredData = [
    {
      "@context": "https://schema.org",
      "@type": "EventSeries",
      "name": "Ocean View Inn & Sports Pub Events",
      "description": "Weekly live music, trivia nights, and special events in Islamorada, Florida Keys",
      "url": `${import.meta.env.VITE_SITE_URL || 'https://example.com'}/events`,
      "location": {
        "@type": "Place",
        "name": "The Ocean View Inn & Sports Pub",
        "address": {
          "@type": "PostalAddress",
          "streetAddress": "84500 Overseas Hwy",
          "addressLocality": "Islamorada",
          "addressRegion": "FL",
          "postalCode": "33036",
          "addressCountry": "US"
        },
        "geo": {
          "@type": "GeoCoordinates",
          "latitude": 24.9470979,
          "longitude": -80.6019239
        }
      },
      "organizer": {
        "@type": "Organization",
        "name": "The Ocean View Inn & Sports Pub",
        "telephone": "(305) 664-8052",
        "url": `${import.meta.env.VITE_SITE_URL || 'https://example.com'}`
      }
    },
    {
      "@context": "https://schema.org",
      "@type": "Event",
      "name": "Jam Night during High Season",
      "description": "Bring your instruments and join our weekly jam session!",
      "startDate": "2025-01-21T19:00:00-05:00",
      "endDate": "2025-01-21T22:00:00-05:00",
      "eventSchedule": {
        "@type": "Schedule",
        "byDay": "Tuesday",
        "repeatFrequency": "P1W",
        "startTime": "19:00:00",
        "endTime": "22:00:00"
      },
      "eventAttendanceMode": "https://schema.org/OfflineEventAttendanceMode",
      "eventStatus": "https://schema.org/EventScheduled",
      "location": {
        "@type": "Place",
        "name": "The Ocean View Inn & Sports Pub",
        "address": {
          "@type": "PostalAddress",
          "streetAddress": "84500 Overseas Hwy",
          "addressLocality": "Islamorada",
          "addressRegion": "FL",
          "postalCode": "33036",
          "addressCountry": "US"
        }
      },
      "organizer": {
        "@type": "Organization",
        "name": "The Ocean View Inn & Sports Pub",
        "telephone": "(305) 664-8052"
      },
      "offers": {
        "@type": "Offer",
        "price": "0",
        "priceCurrency": "USD",
        "availability": "https://schema.org/InStock"
      }
    },
    {
      "@context": "https://schema.org",
      "@type": "Event",
      "name": "Flip Night with Karaoke",
      "description": "Join us for Flip Night - flip a coin for a free drink! Sing your heart out with karaoke all night long.",
      "startDate": "2025-01-22T20:00:00-05:00",
      "endDate": "2025-01-23T01:00:00-05:00",
      "eventSchedule": {
        "@type": "Schedule",
        "byDay": "Wednesday",
        "repeatFrequency": "P1W",
        "startTime": "20:00:00",
        "endTime": "01:00:00"
      },
      "eventAttendanceMode": "https://schema.org/OfflineEventAttendanceMode",
      "eventStatus": "https://schema.org/EventScheduled",
      "location": {
        "@type": "Place",
        "name": "The Ocean View Inn & Sports Pub",
        "address": {
          "@type": "PostalAddress",
          "streetAddress": "84500 Overseas Hwy",
          "addressLocality": "Islamorada",
          "addressRegion": "FL",
          "postalCode": "33036",
          "addressCountry": "US"
        }
      },
      "organizer": {
        "@type": "Organization",
        "name": "The Ocean View Inn & Sports Pub",
        "telephone": "(305) 664-8052"
      },
      "offers": {
        "@type": "Offer",
        "price": "0",
        "priceCurrency": "USD",
        "availability": "https://schema.org/InStock"
      }
    },
    {
      "@context": "https://schema.org",
      "@type": "Event",
      "name": "Steak Night",
      "description": "A local favorite for over 20 years! Every Thursday, we serve premium steaks grilled to perfection. Choose from ribeye, New York strip, or filet mignon, served with your choice of sides.",
      "startDate": "2025-01-23T17:00:00-05:00",
      "endDate": "2025-01-24T01:00:00-05:00",
      "eventSchedule": {
        "@type": "Schedule",
        "byDay": "Thursday",
        "repeatFrequency": "P1W",
        "startTime": "17:00:00",
        "endTime": "01:00:00"
      },
      "eventAttendanceMode": "https://schema.org/OfflineEventAttendanceMode",
      "eventStatus": "https://schema.org/EventScheduled",
      "location": {
        "@type": "Place",
        "name": "The Ocean View Inn & Sports Pub",
        "address": {
          "@type": "PostalAddress",
          "streetAddress": "84500 Overseas Hwy",
          "addressLocality": "Islamorada",
          "addressRegion": "FL",
          "postalCode": "33036",
          "addressCountry": "US"
        }
      },
      "organizer": {
        "@type": "Organization",
        "name": "The Ocean View Inn & Sports Pub",
        "telephone": "(305) 664-8052"
      }
    },
    {
      "@context": "https://schema.org",
      "@type": "Event",
      "name": "Live Music After Football Season",
      "description": "Relax and unwind every Sunday afternoon with live acoustic performances on our outdoor patio. Enjoy ocean breezes, tropical cocktails, and the sounds of talented local musicians.",
      "startDate": "2025-01-26T14:00:00-05:00",
      "endDate": "2025-01-26T17:00:00-05:00",
      "eventSchedule": {
        "@type": "Schedule",
        "byDay": "Sunday",
        "repeatFrequency": "P1W",
        "startTime": "14:00:00",
        "endTime": "17:00:00"
      },
      "eventAttendanceMode": "https://schema.org/OfflineEventAttendanceMode",
      "eventStatus": "https://schema.org/EventScheduled",
      "location": {
        "@type": "Place",
        "name": "The Ocean View Inn & Sports Pub",
        "address": {
          "@type": "PostalAddress",
          "streetAddress": "84500 Overseas Hwy",
          "addressLocality": "Islamorada",
          "addressRegion": "FL",
          "postalCode": "33036",
          "addressCountry": "US"
        }
      },
      "organizer": {
        "@type": "Organization",
        "name": "The Ocean View Inn & Sports Pub",
        "telephone": "(305) 664-8052"
      },
      "offers": {
        "@type": "Offer",
        "price": "0",
        "priceCurrency": "USD",
        "availability": "https://schema.org/InStock"
      }
    }
  ];

  return (
    <div className="min-h-screen bg-white">
      <SEOHead
        title="Events & Live Music Islamorada | Ocean View Inn Florida Keys Entertainment"
        description="Join us for weekly live music, trivia nights, and special events at Ocean View Inn in Islamorada, Florida Keys. Check our event calendar for upcoming entertainment and performances."
        keywords="Islamorada events, Florida Keys live music, trivia night, Ocean View Inn entertainment, weekly events"
        canonical={`${import.meta.env.VITE_SITE_URL || 'https://example.com'}/events`}
        ogTitle="Events & Live Music | Ocean View Inn Islamorada"
        ogDescription="Join us for weekly live music, trivia nights, and special events in the heart of the Florida Keys"
        ogImage="https://readdy.ai/api/search-image?query=Live%20music%20performance%20at%20tropical%20Florida%20Keys%20venue%20with%20musicians%20on%20stage%2C%20audience%20enjoying%20entertainment%2C%20warm%20atmospheric%20lighting%2C%20simple%20clean%20background%2C%20festive%20island%20atmosphere%2C%20concert%20event%20style&width=1200&height=630&seq=events-page-og&orientation=landscape"
        ogUrl={`${import.meta.env.VITE_SITE_URL || 'https://example.com'}/events`}
        structuredData={structuredData}
        geoPosition="24.9470979;-80.6019239"
        geoRegion="US-FL"
        geoPlacename="Islamorada, Florida"
      />
      <Header />
      <main className="pt-20">
        <section className="relative h-[400px] flex items-center justify-center overflow-hidden">
          <div
            className="absolute inset-0 bg-cover bg-center"
            style={{
              backgroundImage: 'url(https://theocean-view.com/wp-content/uploads/2016/03/phoca_thumb_l_dsc_0528.jpg)',
            }}
          >
            <div className="absolute inset-0 bg-slate-900/60"></div>
          </div>
          <div className="relative z-10 text-center text-white max-w-4xl mx-auto px-4">
            <h1 className="text-5xl md:text-6xl font-bold mb-4 font-serif">Events & Entertainment</h1>
            <p className="text-xl text-slate-200">
              Private Parties, Live music, Special dinners, and Authentic Keys entertainment
            </p>
          </div>
        </section>

        <section className="py-20 bg-slate-50">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
              <div>
                <h2 className="text-4xl md:text-5xl font-bold text-slate-900 mb-6 font-serif">
                  Private Bayfront Event Venue
                </h2>
                <p className="text-lg text-slate-600 mb-8 leading-relaxed">
                  Host your special celebration at The Ocean View with stunning bayfront views and authentic Florida Keys atmosphere. Our versatile venue is perfect for intimate gatherings and memorable occasions.
                </p>
                
                <div className="space-y-6 mb-8">
                  <div className="flex items-start space-x-4">
                    <div className="w-12 h-12 bg-gradient-to-br from-blue-600 to-cyan-500 rounded-xl flex items-center justify-center flex-shrink-0">
                      <i className="ri-group-line text-2xl text-white"></i>
                    </div>
                    <div>
                      <h3 className="text-xl font-bold text-slate-900 mb-2">Private Parties & Celebrations</h3>
                      <p className="text-slate-600">Birthdays, anniversaries, family reunions, and special milestones with waterfront dining</p>
                    </div>
                  </div>
                  
                  <div className="flex items-start space-x-4">
                    <div className="w-12 h-12 bg-gradient-to-br from-green-600 to-emerald-500 rounded-xl flex items-center justify-center flex-shrink-0">
                      <i className="ri-briefcase-line text-2xl text-white"></i>
                    </div>
                    <div>
                      <h3 className="text-xl font-bold text-slate-900 mb-2">Corporate Events</h3>
                      <p className="text-slate-600">Team building, company retreats, and business meetings in a relaxed Keys setting</p>
                    </div>
                  </div>
                  
                  <div className="flex items-start space-x-4">
                    <div className="w-12 h-12 bg-gradient-to-br from-purple-600 to-pink-500 rounded-xl flex items-center justify-center flex-shrink-0">
                      <i className="ri-heart-line text-2xl text-white"></i>
                    </div>
                    <div>
                      <h3 className="text-xl font-bold text-slate-900 mb-2">Wedding Receptions</h3>
                      <p className="text-slate-600">Intimate wedding celebrations with bayfront views and tropical ambiance</p>
                    </div>
                  </div>
                </div>

                <div className="flex flex-col sm:flex-row gap-4">
                  <a
                    href="tel:+13056648052"
                    className="inline-flex items-center justify-center px-8 py-4 bg-gradient-to-r from-blue-600 to-cyan-500 text-white rounded-lg font-semibold hover:shadow-xl transform hover:scale-105 transition-all duration-300 whitespace-nowrap"
                  >
                    <i className="ri-phone-line mr-2"></i>
                    Call to Book
                  </a>
                  <a
                    href="mailto:resinfo@theocean-view.com"
                    className="inline-flex items-center justify-center px-8 py-4 border-2 border-slate-300 text-slate-700 rounded-lg font-semibold hover:border-slate-400 hover:bg-slate-50 transition-all duration-300 whitespace-nowrap"
                  >
                    <i className="ri-mail-line mr-2"></i>
                    Email Inquiry
                  </a>
                </div>
              </div>

              <div className="relative">
                <img
                  src="https://static.readdy.ai/image/a0544820e0625081891e0a711cac5596/be55f5095995eedd9efa00afb5af563b.jpeg"
                  alt="Private bayfront event venue at Ocean View Inn"
                  className="w-full h-[400px] object-cover rounded-2xl shadow-2xl"
                  loading="lazy"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-slate-900/20 to-transparent rounded-2xl"></div>
              </div>
            </div>

            <div className="mt-16 grid grid-cols-1 md:grid-cols-3 gap-8">
              <div className="bg-white rounded-2xl p-8 shadow-lg text-center">
                <div className="w-16 h-16 bg-gradient-to-br from-orange-500 to-red-500 rounded-2xl flex items-center justify-center mx-auto mb-6">
                  <i className="ri-restaurant-2-line text-3xl text-white"></i>
                </div>
                <h3 className="text-xl font-bold text-slate-900 mb-3">Full Catering Menu</h3>
                <p className="text-slate-600">Customized menus featuring our signature dishes, appetizers, and tropical cocktails</p>
              </div>

              <div className="bg-white rounded-2xl p-8 shadow-lg text-center">
                <div className="w-16 h-16 bg-gradient-to-br from-blue-500 to-cyan-500 rounded-2xl flex items-center justify-center mx-auto mb-6">
                  <i className="ri-landscape-line text-3xl text-white"></i>
                </div>
                <h3 className="text-xl font-bold text-slate-900 mb-3">Waterfront Setting</h3>
                <p className="text-slate-600">Stunning bay views with tropical landscaping and authentic Keys atmosphere</p>
              </div>

              <div className="bg-white rounded-2xl p-8 shadow-lg text-center">
                <div className="w-16 h-16 bg-gradient-to-br from-green-500 to-emerald-500 rounded-2xl flex items-center justify-center mx-auto mb-6">
                  <i className="ri-customer-service-2-line text-3xl text-white"></i>
                </div>
                <h3 className="text-xl font-bold text-slate-900 mb-3">Event Coordination</h3>
                <p className="text-slate-600">Dedicated staff to help plan and execute your perfect Florida Keys celebration</p>
              </div>
            </div>
          </div>
        </section>

        <section className="py-20 bg-white">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="max-w-3xl mx-auto text-center mb-16">
              <h2 className="text-4xl font-bold text-slate-900 mb-6 font-serif">
                Weekly Events Schedule
              </h2>
              <p className="text-lg text-slate-600 leading-relaxed">
                Experience the best of Florida Keys entertainment at The Ocean View. From live music to special dining events, there's always something happening at our sports pub!
              </p>
            </div>

            <div className="space-y-12">
              {events.map((event, index) => (
                <div
                  key={index}
                  className={`bg-white rounded-2xl shadow-xl overflow-hidden ${
                    index % 2 === 0 ? '' : ''
                  }`}
                >
                  <div className="grid grid-cols-1 lg:grid-cols-2 gap-0">
                    <div className={`${index % 2 === 0 ? 'order-1' : 'order-1 lg:order-2'}`}>
                      <img
                        src={event.image}
                        alt={event.title}
                        className="w-full h-full min-h-[300px] object-cover"
                        loading="lazy"
                      />
                    </div>
                    <div className={`p-8 md:p-12 flex flex-col justify-center ${index % 2 === 0 ? 'order-2' : 'order-2 lg:order-1'}`}>
                      <div className={`inline-flex items-center justify-center w-16 h-16 bg-gradient-to-br ${event.color} rounded-2xl mb-6`}>
                        <i className={`${event.icon} text-3xl text-white`}></i>
                      </div>
                      <div className="mb-4">
                        <span className="text-sm font-semibold text-slate-500 uppercase tracking-wider">
                          Every {event.day}
                        </span>
                      </div>
                      <h3 className="text-3xl md:text-4xl font-bold text-slate-900 mb-4 font-serif">
                        {event.title}
                      </h3>
                      <div className="flex items-center space-x-2 text-slate-600 mb-6">
                        <i className="ri-time-line text-xl"></i>
                        <span className="font-medium">{event.time}</span>
                      </div>
                      <p className="text-lg text-slate-600 leading-relaxed mb-6">
                        {event.description}
                      </p>
                      <div className="flex flex-col sm:flex-row gap-4">
                        <a
                          href="tel:+13056648052"
                          className="inline-flex items-center justify-center px-6 py-3 bg-gradient-to-r from-blue-600 to-cyan-500 text-white rounded-lg font-semibold hover:shadow-xl transform hover:scale-105 transition-all duration-300 whitespace-nowrap"
                        >
                          <i className="ri-phone-line mr-2"></i>
                          Call for Details
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>

        <section className="py-20 bg-slate-50">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="bg-gradient-to-br from-slate-900 to-slate-800 rounded-2xl p-8 md:p-12 text-white">
              <div className="max-w-3xl mx-auto text-center">
                <h3 className="text-3xl font-bold mb-4">Stay Updated on Special Events</h3>
                <p className="text-lg text-slate-300 mb-8">
                  Follow us on social media for announcements about special events, holiday celebrations, and guest performers. Don't miss out on the best entertainment in the Florida Keys!
                </p>
                <div className="flex justify-center space-x-4">
                  <a
                    href="https://www.facebook.com/The-OceanView-Motel-and-Sports-Pub-176655585715394"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="w-12 h-12 bg-blue-600 rounded-full flex items-center justify-center hover:bg-blue-700 transition-colors"
                    aria-label="Facebook"
                  >
                    <i className="ri-facebook-fill text-2xl"></i>
                  </a>
                  <a
                    href="https://www.instagram.com/oceanview_inn_pub/"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="w-12 h-12 bg-pink-600 rounded-full flex items-center justify-center hover:bg-pink-700 transition-colors"
                    aria-label="Instagram"
                  >
                    <i className="ri-instagram-fill text-2xl"></i>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
};

export default EventsPage;
